import view from './view.html';

/* @ngInject */
export default function () {
	const parseFile = (file) => {
		let name      = file.name;
		let extension = '';

		const extensionSeparator = file.name.lastIndexOf('.');

		if (extensionSeparator !== -1) {
			name      = file.name.substring(0, extensionSeparator);
			extension = file.name.substring(extensionSeparator + 1);
		}

		return {
			name,
			extension,
			size:     file.size,
			mimeType: file.type,
		};
	};

	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			directoryId: '=',
			documentId:  '=',
		},
		controller: /* @ngInject */ ($scope, DocumentsDocuments, STATUSES) => {
			$scope.STATUSES = STATUSES;

			$scope.file = null;

			$scope.progress         = 0;
			$scope.progressUploaded = 0;

			$scope.status = STATUSES.UNLOADED;

			$scope.$watch('file', (newValue) => {
				if (newValue) {
					const file = parseFile(newValue);

					const document = {
						name:        file.name,
						directory:   $scope.directoryId,
						version:     {
							version:   'Version 1',
							name:      file.name,
							extension: file.extension,
							fileSize:  file.size,
							mimeType:  file.mimeType,
						},
						permissions: null,
					};

					$scope.status = STATUSES.LOADING;

					DocumentsDocuments.post(document, {
						                  include: 'latestVersion.uploadForm',
					                  })
					                  .then((returnedDocument) => {
						                  $scope.documentId = returnedDocument.id;

						                  const latestVersion = returnedDocument.latestVersion;
						                  const uploadForm    = latestVersion.uploadForm;

						                  $scope.progress         = 0;
						                  $scope.progressUploaded = 0;

						                  return DocumentsDocuments.uploadToStorage(uploadForm, newValue);
					                  })
					                  .then((storageResponse) => {
						                  $scope.status = STATUSES.LOADED;
					                  }, (storageError) => {
						                  throw storageError;
					                  }, (storageProgressEvent) => {
						                  $scope.progress         = parseInt(storageProgressEvent.loaded / storageProgressEvent.total * 100);
						                  $scope.progressUploaded = storageProgressEvent.loaded;
					                  })
					                  .catch((error) => {
						                  $scope.status = STATUSES.ERRORED;

						                  $scope.progress         = 0;
						                  $scope.progressUploaded = 0;

						                  $scope.documentId = null;
					                  });
				}
			});
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/documentUpload/index.js